module.exports = __webpack_public_path__ + "img/ss-sched-1.2a08df2a.jpg";